const RESERVED_LABELS = ['www']

// Returns the leading hostname label when the current host is exactly
// `<label>.<VUE_APP_BASE_DOMAIN>`, so a subdomain-form address request
// (e.g. myapp.localhost) can be resolved the same way as its path form
// (e.g. localhost/myapp). Returns null for the bare base domain, www, or
// any hostname that doesn't match that shape.
export function getSubdomainCode(hostname = window.location.hostname) {
  const baseDomain = process.env.VUE_APP_BASE_DOMAIN
  if (!baseDomain || !hostname) return null

  const suffix = `.${baseDomain}`
  if (!hostname.endsWith(suffix)) return null

  const label = hostname.slice(0, -suffix.length)
  if (!label || label.includes('.') || RESERVED_LABELS.includes(label)) return null

  return label
}
